import { SVGProps } from '@repo/utils/types';
import SVGWrapper from '@repo/icons/SVGWrapper';
import cn from 'classnames';
import React from 'react';

const defaultSize = 24;

export const BirthdayActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon birthday-activity-icon', props.className)}
    viewBox="1 1 14 14"
  >
    <path
      stroke="none"
      d="M12.16 8h-3.5a.2.2 0 0 1-.2-.2V6.64c0-.11.09-.2.2-.2h3.5a.4.4 0 0 1 .41.4v.78a.4.4 0 0 1-.41.4ZM3.84 8a.4.4 0 0 1-.41-.4v-.78c0-.21.18-.39.41-.39h3.5c.11 0 .2.09.2.2V7.8c0 .1-.09.2-.2.2h-3.5Zm3.5 4.57H4.66c-.22 0-.4-.15-.4-.35V8.91c0-.1.08-.18.2-.18h2.88c.11 0 .2.08.2.18v3.49c0 .1-.09.17-.2.17Zm4.4-.35c0 .2-.18.35-.4.35H8.66c-.11 0-.2-.08-.2-.17V8.9c0-.09.09-.17.2-.17h2.88c.12 0 .2.08.2.18v3.31Zm-.22-8.46a1.13 1.13 0 0 1-.8 1.93H8.79a.33.33 0 0 1-.24-.57l1.37-1.36a1.13 1.13 0 0 1 1.6 0Zm-.8.42c-.1 0-.2.04-.27.11l-.64.64h.9a.38.38 0 0 0 .08-.74h-.07Zm-5.75-.75c.3 0 .6.12.8.33l1.37 1.36a.33.33 0 0 1-.24.57H4.97a1.13 1.13 0 1 1 0-2.26Zm-.26.86a.38.38 0 0 0 .26.64h.91l-.64-.64a.38.38 0 0 0-.53 0Z"
    />
  </SVGWrapper>
);

export const EventActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon event-activity-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <g transform="translate(3.43 3.35)">
      <rect
        fill="none"
        strokeWidth="1.14"
        x="-.57"
        y="-.49"
        width="10.29"
        height="10.29"
        rx="2.29"
      />
      <path stroke="none" d="M1.14 0H8c.63 0 1.14.51 1.14 1.14v1.22H0V1.14C0 .51.51 0 1.14 0Z" />
      <rect stroke="none" x="1.59" y="3.51" width="1.44" height="1.44" rx=".31" />
      <rect stroke="none" x="3.88" y="3.51" width="1.44" height="1.44" rx=".31" />
      <rect stroke="none" x="6.16" y="3.51" width="1.44" height="1.44" rx=".31" />
      <rect stroke="none" x="1.59" y="5.79" width="1.44" height="1.44" rx=".31" />
      <rect stroke="none" x="3.88" y="5.79" width="1.44" height="1.44" rx=".31" />
      <rect stroke="none" x="6.16" y="5.79" width="1.44" height="1.44" rx=".31" />
    </g>
  </SVGWrapper>
);

export const NewMemberActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon new-member-activity-icon', props.className)}
    viewBox="1 1 14 14"
  >
    <path
      stroke="none"
      d="M8 2.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0 2.3c-.75 0-1.37.58-1.44 1.34a1.45 1.45 0 0 0-1.7 1 1.5 1.5 0 0 0 .8 1.82c-.37.66-.2 1.5.4 1.96.61.46 1.45.36 1.94-.21.49.57 1.33.67 1.94.21.6-.45.77-1.3.4-1.96a1.5 1.5 0 0 0 .8-1.83 1.45 1.45 0 0 0-1.7-1A1.47 1.47 0 0 0 8 4.8Z"
    />
  </SVGWrapper>
);

export const ReconnectActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon reconnect-activity-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <g transform="translate(2.29 2.86)" strokeLinecap="round" strokeWidth="1.14">
      <ellipse stroke="none" cx="5.71" cy="5.77" rx="1.32" ry="1.33" />
      <path
        fill="none"
        d="M7.63 8.48A3.34 3.34 0 0 0 5.7 2.44a3.34 3.34 0 0 0-1.9 6.05M9.28 10.29A5.78 5.78 0 0 0 5.7 0a5.78 5.78 0 0 0-3.57 10.28"
      />
    </g>
  </SVGWrapper>
);

export const ReminderActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon reminder-activity-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <path
      stroke="none"
      d="M9.22 2.56c.16.13.24.33.21.53l-.61 4.2h2.27a.57.57 0 0 1 .44.92l-4.08 5.1a.57.57 0 0 1-1-.45l.73-4.23H4.9a.57.57 0 0 1-.45-.93l3.96-5.04c.2-.25.55-.3.8-.1Z"
    />
  </SVGWrapper>
);

export const SharedActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon shared-activity-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <g strokeWidth="1.14">
      <path
        fill="none"
        d="M5.77 8a5.4 5.4 0 0 0-2.62 3.03M5.53 6a1.35 1.35 0 0 1 .83-2.55"
        strokeLinecap="round"
      />
      <path
        d="M9.36 9.36c-1.75 0-3.5 2.45-3.5 2.76 0 .31 1.75.5 3.5.5 1.76 0 3.5-.19 3.5-.5 0-.3-1.74-2.76-3.5-2.76ZM9.36 7.45c-.9 0-1.62-.73-1.62-1.63 0-.9.73-1.63 1.62-1.63.9 0 1.62.73 1.62 1.63 0 .9-.73 1.63-1.62 1.63Z"
        strokeLinejoin="round"
      />
    </g>
  </SVGWrapper>
);

export const NewsActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon news-activity-icon', props.className)}
    viewBox="0 0 14 14"
  >
    <path
      strokeWidth="0.96"
      fill="none"
      d="M9.5 9.69V10a1.5 1.5 0 0 0 3 0V8a1 1 0 0 0-1-1h-2 0M4 8.5h3M11 11.5H3.5a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v5.19"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGWrapper>
);

export const PostActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon post-activity-icon', props.className)}
    viewBox="-0.5 -0.5 17 17"
  >
    <path
      strokeWidth="1.14"
      fill="none"
      d="M11.43 2.86a2.85 2.85 0 0 1 2.86 2.85v4.58a2.85 2.85 0 0 1-2.86 2.85H1.7V5.71a2.85 2.85 0 0 1 2.86-2.85ZM4.57 9.14h1.72M4.57 6.86h1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect width="2.86" height="2.86" x="8.57" y="6.57" stroke="none" rx=".86" />
  </SVGWrapper>
);

export const ImportActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon shared-activity-icon', props.className)}
    viewBox="-3 -3 16 16"
  >
    <g strokeWidth="1.2" strokeLinecap="round">
      <path fill="none" strokeLinejoin="round" d="M0 1.11v2.22h2.22M10 8.89V6.67H7.78" />
      <path
        fill="none"
        d="M0 6.1a4.98 4.98 0 0 0 1.58 2.63 5.16 5.16 0 0 0 5.9.63M10 4.09A4.97 4.97 0 0 0 8.53 1.4 5.15 5.15 0 0 0 2.65.55"
      />
    </g>
  </SVGWrapper>
);

export const SocialProfileChangesActivityIcon = ({
  width = defaultSize,
  height = defaultSize,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVGWrapper
    {...{ ...props, width, height, color }}
    className={cn('icon social-profile-changes-activity-icon', props.className)}
    viewBox="0 0 24 24"
  >
    <path fill="none" strokeWidth="2" d="M5 19.5v-15" />
    <path
      d="M8 4h11.84a.75.75 0 0 1 .68 1.06L18.5 9.5l2.02 4.44a.75.75 0 0 1-.68 1.06H8V4Z"
      stroke="none"
    />
  </SVGWrapper>
);
